import { StatusLoading } from 'common/constants/statusLoading';
import { FuelCard } from 'dataSources/Typicode/fuelCards';

export interface FuelCardsData {
  [key: string]: FuelCard;
}

export const STATE = 'FUEL_CARDS';
export interface IState {
  fuelCards: {
    statusLoading: StatusLoading;
    data: FuelCardsData;
    activeFuelCard: string;
  };
}
